import { supabaseClient } from '@/configs/supabase'
import { useSubscription } from '@/lib/supabase/hooks/useSubscription'
import { useUserAuthData } from '@/state/userAuth/hooks'
import { getUserProfile } from '@/lib/supabase/user'
import { TUserSelectKey } from '@/lib/supabase/supabase.interface'

export const useUserProfile = (): TUserSelectKey | undefined => {
  const userAuthData = useUserAuthData()

  const { rows } = useSubscription(
    'User',
    {
      k: 'id',
      v: userAuthData?.id ?? ''
    },
    (): any => getUserProfile(supabaseClient, userAuthData?.id as string)
  )

  return rows?.[0]
}
